import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SiteLayout from "./Layout/SiteLayout";
import Login from "./Login/UI/Login";
import { Provider } from "react-redux";
import store from "./Redux/store";
import { Authorization } from "./Login/Application/Authorization";
import User from "./Users/Domain/User";
import Storage from "./Data/Domain/Storage";
import Version from "./Version/Version";

const id = new Storage("id").getItem();

const DASHBOARD = Authorization([User.SUPERADMIN]);
const USERS = Authorization([User.SUPERADMIN, User.ADMIN, User.CARBON_CREDITS]);
const LOGS = Authorization([User.SUPERADMIN, User.ADMIN, User.AUDITOR]);
const OFFERS = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.CARBON_CREDITS,
]);
const TRANSACTIONS = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.CARBON_CREDITS,
]);
const PROJECTS = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.PROJECTS_VIEWER,
  User.CARBON_CREDITS,
  User.SUSTAINABILITY,
  User.OWNER,
]);
const ADMIN = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.CARBON_MANAGEMENT,
  User.CARBON_CREDITS,
]);
const COMPANIES = Authorization([
  User.LEGAL,
  User.ADMIN,
  User.CARBON_MANAGEMENT,
  User.CARBON_CREDITS,
]);
const ERROR = Authorization([User.SUPERADMIN, User.ADMIN, User.LEGAL]);
const COMMISSIONS = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.LEGAL,
  User.CARBON_CREDITS,
]);
const CRM = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.LEGAL,
  User.CARBON_CREDITS,
]);
const CATEGORIES = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.LEGAL,
  User.CARBON_MANAGEMENT,
]);
const SCOPES = Authorization([User.SUPERADMIN, User.PARTNER]);
const DASHBOARDOFFSET = Authorization([
  User.SUPERADMIN,
  User.LEGAL,
  User.PARTNER,
]);
const TEST = Authorization([User.SUPERADMIN, User.ADMIN, User.LEGAL]);
const SAVING = Authorization([User.SUPERADMIN, User.LEGAL, User.PARTNER]);
const REPORTS = Authorization([User.SUPERADMIN, User.LEGAL, User.PARTNER]);
const OFFSET = Authorization([User.SUPERADMIN, User.LEGAL, User.PARTNER]);
const COLLABORATORS = Authorization([
  User.SUPERADMIN,
  User.LEGAL,
  User.PARTNER,
]);

const SUPPLIERS = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.CARBON_MANAGEMENT,
]);

const AREAS = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.CARBON_MANAGEMENT,
]);

const REPOSITORYPROJECTS = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.CARBON_MANAGEMENT,
]);
const MANAGEDATA = Authorization([User.SUPERADMIN, User.CARBON_MANAGEMENT]);
const FETCHDATA = Authorization([User.SUPERADMIN, User.CARBON_MANAGEMENT]);
const OWNERS = Authorization([
  User.OWNER,
  User.SUPERADMIN,
  User.ADMIN,
]);
const IPFS = Authorization([
  User.OWNER,
  User.SUPERADMIN,
  User.ADMIN,
]);
const PERMISSIONS = Authorization([User.OWNER, User.ADMIN]);
const FILES = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.CARBON_MANAGEMENT,
  User.PARTNER,
]);
const STATIONDATA = Authorization([User.ADMIN]);
const CARBONFLUX = Authorization([User.ADMIN]);
const NFTS = Authorization([User.SUPERADMIN, User.ADMIN]);

const SCRIPTOFFSETS = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.CARBON_MANAGEMENT,
]);
const EQUIVALENTCODES = Authorization([User.ADMIN, User.CARBON_MANAGEMENT]);

const TRANSPORTTYPES = Authorization([User.ADMIN, User.CARBON_MANAGEMENT]);

const COSTCENTERS = Authorization([User.ADMIN, User.CARBON_MANAGEMENT]);

const SHOPIFYDISTANCES = Authorization([User.ADMIN, User.CARBON_MANAGEMENT]);
const SDG = Authorization([User.ADMIN]);
const DOCUMENTS = Authorization([User.OWNER, User.SUSTAINABILITY]);
const DASHBOARDOWNER = Authorization([User.ADMIN, User.OWNER]);
const CARBON_CREDITS = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.OWNER,
]);
const MY_PROFILE = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.OWNER,
]);
const EMISSIONFACTORS  = Authorization([
  User.SUPERADMIN,
  User.ADMIN,
  User.OWNER,
]);
const EVENTS = Authorization([User.PARTNER]);

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path={"/login"} element={<Login />} />
          <Route path={"/logout"} element={<Login logout />} />
          {/* <Route
            path={"/"}
            element={USERS(SiteLayout, { defaultPage: "error" })}
          /> */}
          <Route path={"/"} element={USERS(SiteLayout)} />
          <Route
            path={"/logs"}
            element={LOGS(SiteLayout, { defaultPage: "logs" })}
          />
          <Route
            path={"/logs/:id"}
            element={LOGS(SiteLayout, { defaultPage: "logs" })}
          />
          <Route
            path={"/offers"}
            element={OFFERS(SiteLayout, { defaultPage: "offers" })}
          />
          <Route
            path={"/transactions"}
            element={TRANSACTIONS(SiteLayout, { defaultPage: "transactions" })}
          />
          <Route
            path="/users"
            element={USERS(SiteLayout, { defaultPage: "users" })}
          />
          <Route
            path={"/users/:id"}
            element={USERS(SiteLayout, { defaultPage: "users" })}
          />
          <Route
            path={`/owners/${id}/projects`}
            element={OWNERS(SiteLayout, { defaultPage: "owners" })}
          />
          <Route
            path={"/projects"}
            element={PROJECTS(SiteLayout, { defaultPage: "projects" })}
          />
          <Route
            path={"/projects/:id"}
            element={PROJECTS(SiteLayout, { defaultPage: "projects" })}
          />
          <Route
            path={"/dashboard"}
            element={DASHBOARD(SiteLayout, { defaultPage: "dashboard" })}
          />
          <Route
            path={"/administrator"}
            element={ADMIN(SiteLayout, { defaultPage: "administrator" })}
          />
          <Route
            path={"/administrator/:id"}
            element={ADMIN(SiteLayout, { defaultPage: "administrator" })}
          />
          <Route
            path={"/error"}
            element={ERROR(SiteLayout, { defaultPage: "error" })}
          />
          <Route
            path={"/commissions"}
            element={COMMISSIONS(SiteLayout, { defaultPage: "commissions" })}
          />
          <Route
            path={"/crm"}
            element={CRM(SiteLayout, { defaultPage: "crm" })}
          />
          <Route
            path={"/categories"}
            element={CATEGORIES(SiteLayout, { defaultPage: "categories" })}
          />
          <Route
            path={"/test"}
            element={TEST(SiteLayout, { defaultPage: "test" })}
          />
          <Route
            path={"/scopes"}
            element={SCOPES(SiteLayout, { defaultPage: "scopes" })}
          />
          <Route
            path={"/dashboardOffset"}
            element={DASHBOARDOFFSET(SiteLayout, {
              defaultPage: "dashboardOffset",
            })}
          />
          <Route
            path={"/saving"}
            element={SAVING(SiteLayout, { defaultPage: "saving" })}
          />
          <Route
            path={"/reports"}
            element={REPORTS(SiteLayout, { defaultPage: "reports" })}
          />
          <Route
            path={"/offset"}
            element={OFFSET(SiteLayout, { defaultPage: "offset" })}
          />
          <Route
            path={"/collaborators"}
            element={COLLABORATORS(SiteLayout, {
              defaultPage: "collaborators",
            })}
          />
          <Route
            path={"/suppliers"}
            element={SUPPLIERS(SiteLayout, { defaultPage: "suppliers" })}
          />
          <Route
            path={"/areas"}
            element={AREAS(SiteLayout, { defaultPage: "areas" })}
          />
          <Route
            path={"/repositoryProjects"}
            element={REPOSITORYPROJECTS(SiteLayout, {
              defaultPage: "repositoryProjects",
            })}
          />
          <Route
            path={"/manageData"}
            element={MANAGEDATA(SiteLayout, { defaultPage: "manageData" })}
          />
          <Route
            path={`/owners/${id}/carbonCredits`}
            element={CARBON_CREDITS(SiteLayout, {
              defaultPage: "carbonCredits",
            })}
          />
          <Route
            path="/projects/:recordId/ipfs"
            element={IPFS(SiteLayout, { defaultPage: "ipfs" })}
          />
          {/* <Route
            path={"/permissions"}
            element={PERMISSIONS(SiteLayout, { defaultPage: "permissions" })}
          /> */}
          <Route
            path={`/owners/${id}/permissions`}
            element={PERMISSIONS(SiteLayout, { defaultPage: "permissions" })}
          />
          <Route
            path={"/fetchData"}
            element={FETCHDATA(SiteLayout, { defaultPage: "fetchData" })}
          />
          <Route
            path="/projects/:recordId/generals"
            element={IPFS(SiteLayout, { defaultPage: "generals" })}
          />
          <Route
            path="/projects/:recordId/images"
            element={IPFS(SiteLayout, { defaultPage: "images" })}
          />
          <Route
            path="/files"
            element={FILES(SiteLayout, { defaultPage: "files" })}
          />
          <Route
            path="/projects/:recordId/transactions"
            element={IPFS(SiteLayout, { defaultPage: "transactionsProjects" })}
          />
          <Route
            path="/StationData"
            element={STATIONDATA(SiteLayout, { defaultPage: "StationData" })}
          />
          <Route
            path="/carbonflux"
            element={CARBONFLUX(SiteLayout, { defaultPage: "carbonflux" })}
          />
          <Route
            path="/nfts"
            element={NFTS(SiteLayout, { defaultPage: "nfts" })}
          />
          <Route
            path="/equivalentCodes"
            element={EQUIVALENTCODES(SiteLayout, {
              defaultPage: "equivalentCodes",
            })}
          />

          <Route
            path="/transportTypes"
            element={TRANSPORTTYPES(SiteLayout, {
              defaultPage: "transportTypes",
            })}
          />
          <Route
            path="/costCenters"
            element={COSTCENTERS(SiteLayout, { defaultPage: "costCenters" })}
          />
          <Route
            path={"/scriptOffsets"}
            element={SCRIPTOFFSETS(SiteLayout, {
              defaultPage: "scriptOffsets",
            })}
          />
          <Route
            path="/shopifyDistances"
            element={SHOPIFYDISTANCES(SiteLayout, {
              defaultPage: "shopifyDistances",
            })}
          />
          <Route
            path="/sdgs"
            element={SDG(SiteLayout, { defaultPage: "SDG" })}
          />
          <Route
            path="/my-profile"
            element={MY_PROFILE(SiteLayout, { defaultPage: "my_profile" })}
          />
          <Route
            path="/documents"
            element={DOCUMENTS(SiteLayout, { defaultPage: "documents" })}
          />
          <Route
            path={`/owners/${id}/documents`}
            element={DOCUMENTS(SiteLayout, { defaultPage: "documents" })}
          />
          <Route path="/version" element={<Version />} />
          
          <Route
            path={`/dashboardOwner`}
            element={DASHBOARDOWNER(SiteLayout, {
              defaultPage: "dashboardOwner",
            })}
          />
            <Route
            path="/emissionFactors"
            element={EMISSIONFACTORS(SiteLayout, { defaultPage: "emissionFactors" })}
          />
           <Route
            path="/events"
            element={EVENTS(SiteLayout, { defaultPage: "events" })}
          />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
